import styled from 'styled-components';


export const NormalUserSection = styled.section`
    width: 100%;
    background: #DDF5F6;
    padding: 60px 0px 51px;
    @media screen and (max-width:1199px) {
     margin-top: 100px;
    } 
`;


export const NormalUserContentBox = styled.div` 
    width: 100%;
    background: #34A853;
    border-radius: 10px;
    padding: 20px;
    color: #fff;
    font-size: 16px;
    font-family: 'Jost', sans-serif;
    line-height: 26px;

    &.blue-box-background{
        background: #33A7AE;
        margin-top: 20px;
    }
`;

export const NormalUserText = styled.p`
    margin:0;
    max-width: 847px;
`;


export const FindNonprofitSection = styled.section`
    width: 100%;
    background: #DDF5F6;
    padding-bottom: 50px;
`;

export const FindNonprofitText = styled.h2`
    color: #01606F;
    font-size: 40px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 58px;
@media screen and (max-width:1199px) {
      font-size: 35px;
      line-height: 40px;
  }
  @media screen and (max-width:991px) {
      font-size: 30px;
      line-height: 35px;
  }
  @media screen and (max-width:575px) {
      font-size: 28px;
      line-height: 25px;
      margin-bottom: 0;
  }
`;

export const NonprofitWrap = styled.div`
    width: 100%;
    margin-top: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 60px 24px;
    flex-wrap: wrap;

`;

export const NonprofitBox = styled.div`
    width: calc(50% - 12px);
    background: #FFFFFF;
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 500;
    line-height: 26px;
    border-radius: 15px;
    padding: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px 23px;
    flex-wrap: wrap;
    position: relative;  
    @media screen and (max-width:575px) {
     width:100%;   
    }
    &:first-child{
        margin-bottom: 187px;
      @media screen and (max-width:575px) {
         margin-bottom: 0px;
        }
    }

    &:nth-child(2){
        margin-top: 230px;
        @media screen and (max-width:575px) {
          margin-top: 0px;
        }
    }

    &:nth-child(3){
        margin-top: -150px;
         @media screen and (max-width:575px) {
          margin-top: 0px;
        }

    }

    &:last-child{
        width: 100%;
    }

    &.non-profit-odd{
        position: relative;
        &::before{
            content: '';
            position: absolute;
            width: 316px;
            height: 240px;
            border: 2px dashed #33A7AE;
            border-left: none;
            border-bottom: none;
            right: -316px;
            top: 114%;
            bottom: 0;
            margin: auto;
            transform: translateY(-50%);
         @media screen and (max-width:575px) {
            display:none;
         }
        }
    }

    &.non-profit-even{
        position: relative;
        &::before{
            content: '';
            position: absolute;
            width: 316px;
            height: 140px;
            border: 2px dashed #33A7AE;
            border-right: none;
            border-bottom: none;
            left: -316px;
            top: 50%;
            bottom: auto;
            margin: auto;
            transform: translateY(0%);
        }
    }
`;

export const NonprofitCounterBox = styled.div`
    width: 100%;
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 500;
    line-height: 26px;
    border-radius: 15px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px 23px;
    @media screen and (max-width:991px) {
    font-size: 16px;
    line-height: 22px;
    } 
`;

export const NonprofitNumber = styled.div`
    width: 80px;
    min-width: 80px;
    height: 80px;
    background: #33A7AE;
    border-radius: 15px;
    color: #fff;
    font-size: 30px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
     @media screen and (max-width:1199px) {
        width: 70px;
        min-width: 70px;
        height: 70px;
        font-size:30px;
      } 
    @media screen and (max-width:991px) {
        width: 60px;
        min-width: 60px;
        height: 60px;
        font-size: 25px;
      } 
    @media screen and (max-width:767px) {
        width: 50px;
        min-width: 50px;
        height:50px;
        font-size: 20px;
      } 
`;

export const NonprofitText = styled.p`
    margin-bottom: 15px;
    &:last-child{
        margin-bottom: 0px;
    }
`;
export const NonprofitBoxImage = styled.div`
    width: 100%;

    img{
        width: 100%;
        height: 100%;
        display: block;
    }
`;

export const NonprofitForm = styled.div`
    width: 100%;
    margin-bottom: 10px;
     .search-header{
        box-shadow: 0px 0px 20px #0000001A;
          @media screen and (max-width:575px) {
    .input-group .form-control {
            font-size: 14px;
            line-height: 25px;
       }
       } 
    }
`;